import { _Article_liquid, _Collection_liquid, _Page_liquid_json } from "/_types";
import { Image } from "/image";
import clsx from "clsx";
import { FC } from "react";

export const ContentCard: FC<
  (_Collection_liquid | _Page_liquid_json | _Article_liquid) & {
    type: "collections" | "blogs" | "pages";
  }
> = ({ type, ...props }) => {
  const image = "image" in props ? props.image : null;
  return (
    <article className="relative flex flex-col items-stretch space-y-1 ">
      <a
        className="relative grid h-0 w-full pb-[100%] outline-none hf:outline-none"
        href={`/${type}/${props.handle}`}
      >
        <div
          className="absolute inset-0 h-full w-full overflow-hidden"
          style="background: transparent;"
        >
          <Image
            src={image?.src}
            width={500}
            maxWidth={640}
            alt={image?.alt}
            className={clsx("inset-0 h-full w-full select-none object-cover")}
          />
        </div>
      </a>

      <div className="relative flex flex-1 flex-col items-stretch space-y-1 px-3 pb-3">
        <h1 className=" inline-flex pt-2 text-base font-semibold tracking-tight">
          <a
            className="outline-none hf:underline hf:outline-none"
            data-card-title=""
            href={`/${type}/${props.handle}`}
          >
            {props.title}
          </a>
        </h1>
        {type === "collections"
          ? <div className="text-sm text-gray-600">Starting at $19.99</div>
          : null}
        {type === "blogs" || type === "pages"
          ? <div className="text-sm text-gray-600">
              {new Date(props.published_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </div>
          : null}

        <div className="mt-auto flex w-full flex-1 flex-col justify-end self-end text-center">
          <a className="button-primary mt-2 w-full" href={`/${type}/${props.handle}`}>
            <span className="whitespace-nowrap">
              View {type === "collections" ? "collection" : "more"}
            </span>
          </a>
        </div>
      </div>
    </article>
  );
};
